import CustomTypeaheadComponent from './custom-typeahead-component';

/***
 * A typeahead input box that begins providing suggestions as soon as you type into it.
 */
const customTypeahead = angular
    .module('FacilityData.Common.CustomTypeahead', [])
    .component('customTypeahead', CustomTypeaheadComponent)
    .name;

export default customTypeahead;


// WEBPACK FOOTER //
// ./app/common/custom-typeahead/custom-typeahead.js